var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPinDropLYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 13.3333C29.9999 7.81659 25.5166 3.33325 19.9999 3.33325C14.4833 3.33325 9.99992 7.81659 9.99992 13.3333C9.99992 20.8333 19.9999 31.6666 19.9999 31.6666C19.9999 31.6666 29.9999 20.8333 29.9999 13.3333ZM16.6666 13.3333C16.6666 11.4999 18.1666 9.99992 19.9999 9.99992C21.8333 9.99992 23.3333 11.4999 23.3333 13.3333C23.3333 15.1666 21.8499 16.6666 19.9999 16.6666C18.1666 16.6666 16.6666 15.1666 16.6666 13.3333ZM8.33325 33.3333V36.6666H31.6666V33.3333H8.33325Z",
    fill: "#FFC233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinDropLYellow);
export default __webpack_public_path__ + "static/media/icon-pin_drop-l-yellow.334414e0c465fbf9a1c721ce4687e4ce.svg";
export { ForwardRef as ReactComponent };